import anime from 'animejs/lib/anime.es.js';

let duration = 300;
const activeClass = 'is-open-accordion';
const activeBtn = '--active-table-arrow';

export const initAccordion = () => {
    // VARS
    const toggles = document.querySelectorAll('[data-accordion-toggle]');
    if (!toggles.length) return;

    // EVENTS
    toggles.forEach((toggle) => {
        const isHeaderAccordion = toggle.closest('[data-new-switcher]');

        if (!isHeaderAccordion) {
            toggle.addEventListener('click', handleOnClick, false);
        }

        if (isHeaderAccordion && window.innerWidth < 780) {
            toggle.addEventListener('click', handleOnClick, false);
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && document.activeElement.closest('[data-accordion-toggle]')) {
            handleOnClick(document.activeElement);
        }
    });

    // HANDLERS
    function handleOnClick(activeElement) {
        const accordionElement = this || activeElement;
        const accordion = accordionElement.closest('[data-accordion]');

        // customize for features menu
        if (window.innerWidth >= 1024 && accordion.classList.contains('features-menu')) return;

        // customize for features advantage block
        if (window.innerWidth >= 780 && accordion.classList.contains('features-advantage')) return;

        accordion.classList.contains(activeClass) ? closeAccordion(accordion) : openAccordion(accordion);
        changeButtonText(this);
    }

    // FUNCTIONS

    function changeButtonText(toggle) {
        if (!toggle.hasAttribute('data-open-accordion-text')) return;

        const accordion = toggle.closest('[data-accordion]');
        const buttons = accordion.querySelectorAll('[data-accordion-toggle]');

        if (accordion.classList.contains(activeClass)) {
            buttons.forEach((button) => {
                button.textContent = button.dataset.closeAccordionText;
            });
        } else {
            buttons.forEach((button) => {
                button.textContent = button.dataset.openAccordionText;
            });
        }
    }
};

export function openAccordion(accordion) {
    const body = accordion.querySelector('[data-accordion-body]');
    const btn = accordion.querySelector('[btn-table-arrow]');
    const isNewSwitcher = document.querySelector('[data-new-switcher]');
    const height = body.scrollHeight;
    accordion.classList.add(activeClass);

    //Check if there is a button for adding a class. The button exists in the table
    if (btn) {
        btn.classList.add(activeBtn);
    }

    const animationOptions = {
        targets: body,
        height: [0, height],
        easing: 'linear',
        duration: duration,
    };

    if (!isNewSwitcher) {
        animationOptions.complete = function () {
            body.style.height = 'auto';
        };
    }
    anime(animationOptions);
}

export function closeAccordion(accordion) {
    const body = accordion.querySelector('[data-accordion-body]');
    const btn = accordion.querySelector('[btn-table-arrow]');
    const height = body.scrollHeight;
    body.style.height = `${height}px`;
    accordion.classList.remove(activeClass);

    //Check if there is a button for adding a class. The button exists in the table
    if (btn) {
        btn.classList.remove(activeBtn);
    }

    anime({
        targets: body,
        height: 0,
        easing: 'linear',
        duration: duration,
    });
}
